module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 152);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ Heading_Heading; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/Heading/HeadingStyles.ts


var section = Object(external_styled_components_["css"])(["margin:0.707em 0 0.2em;text-transform:uppercase;"]);
var StyledH1 = external_styled_components_default.a.h1.withConfig({
  displayName: "HeadingStyles__StyledH1",
  componentId: "sc-15s3yx3-0"
})(["", ";margin:1.414em 0 0.4em;text-rendering:optimizelegibility;color:", ";", " ", " font-size:", ";font-weight:", ";"], themes_["mixins"].reset('block'), Object(themes_["pickVariant"])('$isSection', {
  "true": Object(themes_["pick"])({
    enterprise: {
      dark: themes_["variables"].gray80,
      light: themes_["variables"].gray45
    },
    prisma: themes_["variables"].contentColorDefault
  }),
  "false": {
    prisma: themes_["variables"].contentColorActive
  }
}), Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["line-height:", ";"], Object(themes_["pickVariant"])('as', {
    h1: '48px',
    h2: '24px',
    h3: '24px',
    h4: '24px',
    h5: '16px'
  }))
}), function (_ref) {
  var $isSection = _ref.$isSection;
  return $isSection && section;
}, Object(themes_["pickVariant"])('as', {
  h1: {
    enterprise: themes_["variables"].fontSizeXXLarge,
    prisma: '36px'
  },
  h2: {
    enterprise: themes_["variables"].fontSizeXLarge,
    prisma: '24px'
  },
  h3: {
    enterprise: themes_["variables"].fontSizeLarge,
    prisma: '20px'
  },
  h4: {
    enterprise: themes_["variables"].fontSize,
    prisma: function prisma(_ref2) {
      var $isSection = _ref2.$isSection;
      return $isSection ? '14px' : '16px';
    }
  },
  h5: function h5(_ref3) {
    var $isSection = _ref3.$isSection;
    return $isSection && Object(themes_["pick"])({
      enterprise: '12px',
      prisma: '13px'
    });
  }
}), function (_ref4) {
  var asElement = _ref4.as,
      $isSection = _ref4.$isSection;
  return asElement === 'h4' && !$isSection ? 'bold' : Object(themes_["pick"])({
    enterprise: themes_["variables"].fontWeightSemiBold,
    prisma: themes_["variables"].fontWeightBold
  });
});

// CONCATENATED MODULE: ./src/Heading/Heading.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var propTypes = {
  children: external_prop_types_default.a.node,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  level: external_prop_types_default.a.oneOf([1, 2, 3, 4, 's', 'ss'])
};
// h1-h6 use the same intrinsic element type
var levelToElement = {
  '1': 'h1',
  '2': 'h2',
  '3': 'h3',
  '4': 'h4',
  s: 'h4',
  ss: 'h5'
};

function Heading(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 2 : _ref$level,
      children = _ref.children,
      elementRef = _ref.elementRef,
      otherProps = _objectWithoutProperties(_ref, ["level", "children", "elementRef"]);

  // @docs-props-type HeadingPropsBase
  var isSection = function isSection(l) {
    return l.toString().charAt(0) === 's';
  };

  return /*#__PURE__*/external_react_default.a.createElement(StyledH1, _extends({
    as: levelToElement[level],
    $isSection: isSection(level),
    "data-test": "heading",
    ref: elementRef
  }, otherProps), children);
}

Heading.propTypes = propTypes;
/* harmony default export */ var Heading_Heading = (Heading);

// CONCATENATED MODULE: ./src/Heading/index.ts


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });